import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const EmailVerificationRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Se não estiver autenticado, redireciona para login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se o email não estiver verificado, redireciona para a página de verificação
  if (!currentUser.emailVerificado) {
    return <Navigate to="/verificar-email" state={{ from: location }} replace />;
  }

  // Se estiver autenticado e com email verificado, permite acesso à rota
  return children;
};

export default EmailVerificationRoute; 